import styled from "styled-components";

export const InLineIcon = styled.div`
  transform: scalex(-1);
`;
